import { render } from "./SemanaCalendario.vue?vue&type=template&id=1c45380b&scoped=true"
import script from "./SemanaCalendario.vue?vue&type=script&lang=js"
export * from "./SemanaCalendario.vue?vue&type=script&lang=js"

import "./SemanaCalendario.vue?vue&type=style&index=0&id=1c45380b&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c45380b"]])

export default __exports__